import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Network } from '@capacitor/network';
import { ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { from, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { AuthenticationService } from '../services/authentication.service';

// const TOKEN_KEY = 'token';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  protected apiURI = environment.api_uri;
  private isToastVisible: boolean;

  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private toast: ToastController,
    private storage: Storage
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.auth.getAuthorizationToken()).pipe(
      switchMap((token) => {
        // console.log('Intercept url:', request.url, 'token:', token);
        const reg = new RegExp(this.apiURI);
        if (request.url.match(reg)) {
          // console.log('Interceptor => uri match apiURI');
          request = request.clone({
            headers: request.headers.set('X-Ulink-App', 'solupass'),
          });
          if (token) {
            request = request.clone({
              headers: request.headers.set('Authorization', 'Bearer ' + token),
            });
          }

          if (!request.headers.has('Content-Type')) {
            request = request.clone({
              headers: request.headers.set('Content-Type', 'application/json'),
            });
          }
          // if (this.debug) {
          //   request = request.clone({ url: this.url + request.url + '?XDEBUG_SESSION_START=1' });
          // }
        }
        return next.handle(request).pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              // do nothing for now
            }
            return event;
          }),
          catchError((error: HttpErrorResponse) => {
            const status = error.status;
            const url = error.url;
            // const escUrl = this.apiURI.replace('.', '\\.');            
            const regex = new RegExp(this.apiURI + '/users/\\d+/otpAuth');
            console.log('regex', regex);
            console.log('url', url);
            console.log('regex.test(url)->', url.match(regex));
            console.log('interceptorErr->', error);
            if (status === 401 && this.auth.isLoggedIn.getValue()) {
              console.log('Interceptor => logout');
              this.auth.logout();
            } else if (status === 403 && !regex.test(url)) {
              this.toast
                .create({
                  message:
                    "Vous n'avez pas la permission d'accéder à cette page.",
                  duration: 3000,
                  color: 'danger',
                  position: 'top',
                })
                .then((toastData) => {
                  toastData.present();
                  this.router.navigate(['/site']);
                });

            } else if (status === 404) {
              return;
            } else if (status !== 401) {
              Network.getStatus().then((status) => {
                if (status.connected) {
                  this.toast
                    .create({
                      message:
                        "Erreur lors de la récupération des données veuillez réessayer.",
                      duration: 3000,
                      // color: 'danger',
                      position: 'top',
                    })
                    .then((toastData) => {
                      toastData.present();
                    });
                } else {
                  if (this.isToastVisible) {
                    return;
                  }
                  this.isToastVisible = true;
                  this.toast.create({
                    message: 'Vous êtes hors ligne.',
                    duration: 3000,
                    icon: 'cloud-offline-outline',
                    // color: 'success',
                    position: 'bottom'
                  }).then((toast: HTMLIonToastElement) => {
                    toast.onDidDismiss().then(() => {
                      this.isToastVisible = false;
                    });
                    toast.present();
                  });
                }
              });
            }
            return throwError(() => error);
          })
        );
      })
    );
  }
}

/*
Copyright 2017-2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
